(() => {
  const SELECTOR = '.ns-home[data-section-id]';

  function initCarousel(root, name) {
    const viewport = root.querySelector(`[data-carousel="${name}"]`);
    if (!viewport || viewport.dataset.ready === 'true') return;

    const prev = root.querySelector(`[data-carousel-prev="${name}"]`);
    const next = root.querySelector(`[data-carousel-next="${name}"]`);
    const status = root.querySelector(`[data-carousel-status="${name}"]`);
    const cards = Array.from(viewport.children);

    if (cards.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    const cardStep = () => {
      const first = cards[0];
      const styles = window.getComputedStyle(viewport);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      return first.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (prev) prev.disabled = viewport.scrollLeft < 6;
      if (next) next.disabled = viewport.scrollLeft > max - 6;
      if (status) {
        const current = Math.min(cards.length, Math.round(viewport.scrollLeft / cardStep()) + 1);
        status.textContent = `${String(current).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      }
    };

    prev?.addEventListener('click', () => {
      viewport.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    viewport.dataset.ready = 'true';
    update();
  }

  function escapeHtml(value) {
    const node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }

  function stripHtml(value) {
    const node = document.createElement('div');
    node.innerHTML = value || '';
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  const journalLinkOverrides = {
    'hygge-bosai-goods-award-2026-triple-award':
      '/blogs/%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B/hygge-bosai-goods-award-2026-triple-award'
  };

  function resolveJournalLink(post) {
    const override = journalLinkOverrides[post?.slug];
    return override
      ? { href: override, attributes: '' }
      : { href: post?.link || '#', attributes: ' target="_blank" rel="noopener"' };
  }

  async function loadJournal(root) {
    const grid = root.querySelector('[data-journal-grid]');
    const snap = root.querySelector('[data-snap-journal]');
    if ((!grid && !snap) || root.dataset.journalReady === 'true') return;
    root.dataset.journalReady = 'true';

    try {
      const response = await fetch(
        'https://www.nesekt.co.jp/wp-json/wp/v2/posts?per_page=6&_embed=wp:featuredmedia',
        { headers: { Accept: 'application/json' } }
      );
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const posts = await response.json();
      if (!Array.isArray(posts) || !posts.length) throw new Error('No posts');

      const recruitmentPattern = /募集|採用|アルバイト|パート/;
      const selectedPosts = posts
        .filter((post) => !recruitmentPattern.test(stripHtml(post?.title?.rendered)))
        .slice(0, 3);

      posts.forEach((post) => {
        if (
          selectedPosts.length < 3
          && !selectedPosts.some((selected) => selected.id === post.id)
        ) {
          selectedPosts.push(post);
        }
      });

      if (snap) {
        snap.innerHTML = selectedPosts.map((post, index) => {
          const media = post?._embedded?.['wp:featuredmedia']?.[0];
          const image = media?.media_details?.sizes?.large?.source_url
            || media?.media_details?.sizes?.medium_large?.source_url
            || media?.source_url
            || '';
          const title = stripHtml(post?.title?.rendered);
          const link = resolveJournalLink(post);

          return `
            <a class="ns-snap-card ns-snap-card--journal" href="${escapeHtml(link.href)}"${link.attributes}>
              <div class="ns-snap-card__media">
                ${image
                  ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">`
                  : '<span class="ns-snap-card__fallback">JOURNAL</span>'}
              </div>
              <span>${escapeHtml(title)}</span>
              <small>${String(index + 1).padStart(2, '0')}</small>
            </a>`;
        }).join('');
        snap.dataset.ready = 'true';
      }

      if (grid) {
        grid.innerHTML = selectedPosts.map((post) => {
          const media = post?._embedded?.['wp:featuredmedia']?.[0];
          const image = media?.media_details?.sizes?.medium_large?.source_url || media?.source_url || '';
          const title = stripHtml(post?.title?.rendered);
          const excerpt = stripHtml(post?.excerpt?.rendered).slice(0, 90);
          const link = resolveJournalLink(post);
          const date = new Intl.DateTimeFormat('ja-JP', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }).format(new Date(post.date));

          return `
            <article class="ns-journal-card">
              <a class="ns-journal-card__image" href="${escapeHtml(link.href)}"${link.attributes}>
                ${image
                  ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">`
                  : '<span class="ns-journal-card__fallback">JOURNAL</span>'}
              </a>
              <div class="ns-journal-card__body">
                <time datetime="${escapeHtml(post.date)}">${escapeHtml(date)}</time>
                <h3><a href="${escapeHtml(link.href)}"${link.attributes}>${escapeHtml(title)}</a></h3>
                <p>${escapeHtml(excerpt)}${excerpt.length >= 90 ? '…' : ''}</p>
                <a class="ns-text-link" href="${escapeHtml(link.href)}"${link.attributes}>記事を読む <span aria-hidden="true">→</span></a>
              </div>
            </article>`;
        }).join('');
        grid.dataset.ready = 'true';
      }
    } catch (error) {
      grid?.classList.add('ns-journal-grid--fallback');
      snap?.classList.add('ns-snap__track--fallback');
    }
  }

  function init(root) {
    ['hero', 'ranking', 'new'].forEach((name) => initCarousel(root, name));
    loadJournal(root);
  }

  document.querySelectorAll(SELECTOR).forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.(SELECTOR) ? event.target : event.target.querySelector?.(SELECTOR);
    if (root) init(root);
  });
})();
